/* eslint-disable prettier/prettier */
/* eslint-disable */

/* DashboardStatCard.tsx */

import React from 'react';
import styles from './DashboardStatCard.module.css';

export interface DashboardStatCardProps {
	title: string;
	value: string | number;

	icon: string;
	iconAlt?: string;

	cardWidth?: string;
	cardHeight?: string;

	backgroundColor?: string;
	borderRadius?: string;

	titleColor?: string;
	valueColor?: string;

	iconBackground?: string;

	titleFontSize?: string;
	valueFontSize?: string;

	padding?: string;

	onClick?: () => void;
}

const DashboardStatCard: React.FC<DashboardStatCardProps> = ({
	title,
	value,

	icon,
	iconAlt = 'icon',

	cardWidth = '340px',
	cardHeight = '138px',

	backgroundColor = '#FFFFFF',
	borderRadius = '10px',

	titleColor = '#1F1F1F',
	valueColor = '#1F1F1F',

	iconBackground = '#DDE9FF',

	titleFontSize = '18px',
	valueFontSize = '64px',

	padding = '16px',

	onClick,
}) => {
	return (
		<div
			className={styles.card}
			onClick={onClick}
			style={{
				width: cardWidth,
				height: cardHeight,
				background: backgroundColor,
				borderRadius,
				padding,
			}}
		>
			{/* TOP */}
			<div className={styles.topSection}>
				<div
					className={styles.iconWrapper}
					style={{
						background: iconBackground,
					}}
				>
					<img src={icon} alt={iconAlt} className={styles.icon} />
				</div>
			</div>

			{/* BOTTOM */}
			<div className={styles.bottomSection}>
				<h3
					className={styles.title}
					style={{
						color: titleColor,
						fontSize: titleFontSize,
					}}
				>
					{title}
				</h3>

				<p
					className={styles.value}
					style={{
						color: valueColor,
						fontSize: valueFontSize,
					}}
				>
					{value}
				</p>
			</div>
		</div>
	);
};

export default DashboardStatCard;
